export enum VISA_TYPE {
  DOMESTIC = 'DOMESTIC',
  SCHENGEN = 'SCHENGEN',
  SCHENGEN_LIMITED = 'SCHENGEN_LIMITED',
}
